import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/authContext";

const ProtectedRoute = (props: any) => {
  const { user, isLoading, emailUsertokenExpired, logout } = useAuth();
  const googleProfileUser: any = localStorage.getItem('googleProfile');
  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (!user && !googleProfileUser) {
    return <Navigate to="/join" replace />;
  }
  if(emailUsertokenExpired() && !googleProfileUser) {
    logout();
    // emailUsertokenExpired() = true (if the "emailUser" is not signed in or the token has expired)
    return <Navigate to="/join" replace />;
  }

    return props.children ? props.children : <Outlet />;;
};

export default ProtectedRoute;